import React from 'react';
import { Divider, Select } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import type { KlaviyoTestFormValues } from './KlaviyoTestFormTypes';

export type SelectOption = { value: string; label: string };

export type ProductPlanFieldsProps = {
	form: UseFormReturnType<KlaviyoTestFormValues>;
	disabled: boolean;
	productOptions: SelectOption[];
	productSubscriptionTypeOptions: SelectOption[];
	/** Overrides the default `getInputProps('productId')` onChange so the parent can reset
	 *  `productSubscriptionTypeId` synchronously when the product changes, instead of via an effect. */
	onProductIdChange: (value: string | null) => void;
	/** Overrides the default `getInputProps('productSubscriptionTypeId')` onChange so the parent
	 *  can suggest a `validTo` date synchronously when a plan is picked, instead of via an effect. */
	onProductSubscriptionTypeIdChange: (value: string | null) => void;
};

export default function ProductPlanFields(props: ProductPlanFieldsProps) {
	const {
		form,
		disabled,
		productOptions,
		productSubscriptionTypeOptions,
		onProductIdChange,
		onProductSubscriptionTypeIdChange,
	} = props;

	return (
		<>
			<Divider label="Product & plan" />
			<Select
				{...form.getInputProps('productId')}
				onChange={onProductIdChange}
				label="Product"
				data={productOptions}
				disabled={disabled}
				withAsterisk
				clearable
				searchable
			/>
			<Select
				{...form.getInputProps('productSubscriptionTypeId')}
				onChange={onProductSubscriptionTypeIdChange}
				label="Subscription type"
				nothingFoundMessage={form.values.productId ? 'No options' : 'Select a product first'}
				data={productSubscriptionTypeOptions}
				disabled={disabled}
				withAsterisk
				clearable
				searchable
			/>
		</>
	);
}
